import { Limiter } from "../../common/enums/limiter";

export class UserLimiter {
  limiter: Limiter;
  name: string;

  constructor(limiter: Limiter = null, name: string = null) {
    this.limiter = limiter;
    this.name = name;
  }
}
